import { getHeaders } from '../headers';

// The job-log endpoints answer 401 to a signed-out JSON request, and 404 to anyone but the job's
// owner. None of those can be fixed by asking again.
const UNAVAILABLE_STATUSES = [401, 403, 404];

const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Sign in again.';
const STATUS_CHECK_FAILED_MESSAGE = "We couldn't check the status of this job. Refresh the page to see the latest.";

// GETs a job-log endpoint as JSON. Asking for JSON explicitly is what turns an expired session into
// a 401 rather than a redirect to the HTML sign-in page, which fetch would follow and report as ok.
//
// Rejects with an Error carrying the HTTP `status` when the response is not ok or its body is not
// JSON, and marks it `unavailable` when polling should stop for good: the session expired, the job
// is not the caller's, or the server answered ok with something other than JSON (the followed
// redirect to the sign-in page). Every other failure (a network error, a 5xx whether its body is
// JSON or Heroku's HTML error page) is left for the caller to treat as transient if it wants to.
export const fetchJobLogJson = async (url) => {
  const response = await fetch(url, {
    method: 'GET',
    headers: { ...getHeaders(), Accept: 'application/json' },
  });

  let body = null;
  let isJson = true;
  try {
    body = await response.json();
  } catch (_e) {
    isJson = false;
  }

  if (response.ok && isJson) return body;

  const reason = isJson ? body?.error || body?.message || response.statusText : 'Response was not JSON';
  const error = new Error(`HTTP ${response.status}: ${reason}`);
  error.status = response.status;
  error.unavailable = UNAVAILABLE_STATUSES.includes(response.status) || (response.ok && !isJson);
  throw error;
};

export const isJobLogUnavailable = (error) => Boolean(error?.unavailable);

// What to tell the user when a poller gives up on a job log, whatever the failure was.
export const jobLogPollingErrorMessage = (error) => (error?.status === 401 ? SESSION_EXPIRED_MESSAGE : STATUS_CHECK_FAILED_MESSAGE);
